import React from "react";
import styled from "styled-components";
import IPTInformation from "../../interfaces/IPTInformation";

const StyledRootDiv = styled.div`
    font-size: 18px;
    text-align: left;
    font-weight: bold;
    margin-bottom: 20px;
    
    .header-name, .header-title {
        position: relative;
        margin-right: 20px;
    }
    
    .header-name:after, .header-title:after {
        content: '';
        right: -10px;
        width: 1px;
        height: 18px;
        position: absolute;
        background: black;
    } 
`;

const StyledSlideInfo = styled.div`
    float: right;
`;

const StyledMoveSlideButton = styled.button`
    background: #2CBFA3;
    padding: 10px 15px;
    border-radius: 5px;
    color: white;
`;

const StyledUserInfo = styled.div`
    padding: 10px 0;
    float: left;
`;

const StyledSlideInfoText = styled.span`
    color: #2CBFA3;
    text-decoration: underline;
`;

interface IPresentationHeaderProps {
    className?: string,
    ptInformation: IPTInformation;
}

const PresentationHeader: React.FC<IPresentationHeaderProps> = (({
                                                                     className,
                                                                     ptInformation
                                                                 }) => {

    const moveSlide = () => {
        ptInformation.tempSlide = ptInformation.currentSlide;
    };

    return (
        <StyledRootDiv className={className}>
            <StyledSlideInfo>
                <span>현재 지원자는 <StyledSlideInfoText>{ptInformation.currentSlide} 슬라이드</StyledSlideInfoText>를 발표하고 있습니다. &nbsp;</span>
                <StyledMoveSlideButton onClick={moveSlide}>발표 슬라이드로 이동</StyledMoveSlideButton>
            </StyledSlideInfo>
            <StyledUserInfo>
                <span className={"header-name"}>{ptInformation.isBlind ? '비공개' : ptInformation.user.name}</span>
                <span className={"header-title"}>{ptInformation.user.recruitNoticeName}</span>
                <span className={"header-description"}>{ptInformation.user.recruitSectorName}</span>
            </StyledUserInfo>
            {/*<button onClick={() => {*/}
            {/*    presentationPlay.currentSlide = (presentationPlay.currentSlide) % presentationPlay.slides.length + 1;*/}
            {/*    presentationPlay.tempSlide = presentationPlay.currentSlide;*/}
            {/*}}>다음쓰</button>*/}
        </StyledRootDiv>
    )
});

export default PresentationHeader;